var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading && _vm.me.is_admin)?_c('LsNavbar',{attrs:{"user":_vm.me}}):_vm._e(),(!_vm.loading && _vm.me.is_admin)?_c('div',{staticClass:"container"},[_c('RouterView')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }